/* eslint-disable */
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
// import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
// import { SaleListUrlSortField } from "@saleor/discounts/urls";
import { WarehouseListUrlSortField } from "@saleor/warehouses/urls";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { ProducttagsList_producttags_edges_node } from "../../types/ProducttagsList";
// import SaleList from "../SaleList";
import ProducttagsList from "../../components/ProducttagsList/ProducttagsList";
import {
  // createFilterStructure,
  SaleFilterKeys,
  SaleListFilterOpts
} from "./filters";

export interface SaleListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<SaleFilterKeys, SaleListFilterOpts>,
    SortPage<WarehouseListUrlSortField>,
    TabPageProps {
  defaultCurrency: string;
  sales: ProducttagsList_producttags_edges_node[];
  toatlCount: number;
}

const ProducttagsListPage: React.FC<SaleListPageProps> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAdd,
  onAll,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  sales,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  // const structure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.producttags) + "(" + toatlCount + ")"
        }
      >
        <Button onClick={onAdd} variant="contained" color="primary">
          <FormattedMessage
            defaultMessage="Create Producttag"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <ProducttagsList tags={sales} {...listProps} />
      </Card>
    </Container>
  );
};
ProducttagsListPage.displayName = "ProducttagsListPage";
export default ProducttagsListPage;
